import { Component } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { MouldLogOverviewModalComponent } from './mould-log-overview-modal/mould-log-overview-modal.component';

@Component({
  selector: 'em-mould-log-overview',
  styleUrls: ['./mould-log.overview.component.less'],
  templateUrl: './mould-log-overview.component.html',
  standalone: false,
})
export class MouldLogOverviewComponent {
  public constructor(private readonly modalService: NzModalService) {}

  public openModal(event: MouseEvent) {
    event.stopPropagation();

    const modal = this.modalService.create({
      nzClosable: true,
      nzContent: MouldLogOverviewModalComponent,
      nzFooter: [
        {
          label: 'Close',
          onClick: () => {
            modal.destroy();
          },
        },
      ],
      nzMaskClosable: true,
      nzTitle: 'Mould log overview',
      nzWidth: '85%',
    });
  }
}
